import { render, staticRenderFns } from "./HaberDetay.vue?vue&type=template&id=173a1eb5&scoped=true&"
import script from "./HaberDetay.vue?vue&type=script&lang=js&"
export * from "./HaberDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a1eb5",
  null
  
)

export default component.exports